// @flow

import React from "react";
import { generateRandomString } from "@transformers/string";
import { BaseHierarchyTree, Radio, Icons } from "../index";
import type { TreeBranch } from "../base-hierarchy-tree";
import { flattenNodes, getParentIds, TYPE_ORGANIZATION } from "../base-hierarchy-tree/util";
import withSearchable from "../searchable-hierarchy-tree";
import type { FlatNodes } from "../base-hierarchy-tree/util";
import "./radio-hierarchy-tree.style.scss";

type Props = $Exact<{
  tree: TreeBranch,
  disabled: boolean,
  selected: number | null,
  expanded: number[],
  onChange: (id: number) => void,
}>;

export class RadioHierarchyTree extends React.Component<Props> {
  static defaultProps = {
    selected: null,
    disabled: false,
    expanded: [],
    onChange: () => undefined,
  };

  flatNodes: FlatNodes;

  constructor(props: Props) {
    super(props);

    this.flatNodes = flattenNodes(props.tree);
  }

  get expandedNodes() {
    return this.props.expanded.concat(getParentIds(this.flatNodes, this.props.selected));
  }

  onRadioClick = (id: number) => () => {
    this.props.onChange(id);
  };

  renderControl = (branch: TreeBranch) => {
    if (branch.data.type !== TYPE_ORGANIZATION) {
      return <span className="material-icons pointer">person</span>;
    }

    return (
      <Radio
        id={"radio-branch-" + branch.data.path + generateRandomString(10) + branch.data.id}
        onChange={this.onRadioClick(branch.data.id)}
        name={"radio-branch"}
        checked={branch.data.id === this.props.selected}
      />
    );
  };

  render() {
    return (
      <BaseHierarchyTree
        className="radio-tree"
        tree={this.props.tree}
        disabled={this.props.disabled}
        expanded={this.expandedNodes}
        hasControl={true}
        renderControl={this.renderControl}
      />
    );
  }
}

export default withSearchable(RadioHierarchyTree);
